interface ServicesGridProps {
  activeCategory: string;
  setActiveCategory: (category: string) => void;
}

const ServicesGrid = ({ activeCategory, setActiveCategory }: ServicesGridProps) => {
  const categories = ['Cutting', 'Colouring', 'Styling', 'Treatments'];

  const servicesData: Record<string, Array<{ name: string; description: string; price: string }>> = {
    Cutting: [
      { name: 'Ladies Cut', description: 'Precision cutting with consultation and styling finish', price: '£45' },
      { name: 'Gents Cut', description: 'Classic or contemporary cut with wash and finish', price: '£28' },
      { name: 'Restyle', description: 'Complete transformation with extended consultation', price: '£55' },
      { name: 'Fringe Trim', description: 'Quick refresh between appointments', price: '£12' },
    ],
    Colouring: [
      { name: 'Full Head Colour', description: 'Complete coverage with premium colour products', price: '£65+' },
      { name: 'Root Touch-Up', description: 'Refresh regrowth for lasting vibrancy', price: '£48' },
      { name: 'Highlights', description: 'Foil highlights for dimension and depth', price: '£85+' },
      { name: 'Balayage', description: 'Hand-painted natural-looking colour', price: '£95+' },
      { name: 'Colour Correction', description: 'Expert fixing of previous colour issues', price: 'From £120' },
    ],
    Styling: [
      { name: 'Blow Dry', description: 'Professional styling with premium products', price: '£32' },
      { name: 'Special Occasion Hair', description: 'Updos and styles for weddings and events', price: '£65+' },
      { name: 'Bridal Hair', description: 'Trial and wedding day styling', price: 'From £95' },
    ],
    Treatments: [
      { name: 'Olaplex Treatment', description: 'Bond-building treatment for healthier hair', price: '£35' },
      { name: 'Deep Conditioning', description: 'Intensive moisture and repair treatment', price: '£25' },
      { name: 'Scalp Treatment', description: 'Soothing treatment for scalp health', price: '£28' },
    ],
  };

  return (
    <section className="bg-white py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-4">
            <nav className="sticky top-32 space-y-2">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setActiveCategory(category)}
                  className={`w-full text-left px-4 py-3 rounded-l-2xl font-sans font-semibold transition-all cursor-pointer ${
                    activeCategory === category
                      ? 'bg-sage/10 text-sage'
                      : 'text-gray-600 hover:bg-gray-50'
                  }`}
                >
                  {category}
                </button>
              ))}
            </nav>
          </div>

          <div className="col-span-8">
            <div className="space-y-20">
              {categories.map((category) => (
                <div key={category} id={category.toLowerCase()}>
                  <h2 className="text-4xl font-bold text-charcoal font-serif mb-6 pb-4 border-b border-gray-200">
                    {category}
                  </h2>
                  <div className="space-y-8">
                    {servicesData[category].map((service, index) => (
                      <div key={index} className="flex justify-between items-start">
                        <div className="flex-1">
                          <h3 className="text-2xl font-semibold text-charcoal font-serif mb-2">
                            {service.name}
                          </h3>
                          <p className="text-base text-gray-600 font-sans leading-relaxed max-w-xl">
                            {service.description}
                          </p>
                        </div>
                        <div className="text-xl font-semibold text-sage font-sans whitespace-nowrap ml-8">
                          {service.price}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;